<script setup>
import { computed } from 'vue';
import {
  UserPlus,
  Folder,
  Tag,
  MessageSquare,
  Mail,
  Send,
  Cloud,
  Globe,
  Users,
  AtSign,
  MailX,
  ChartNoAxesColumn,
  Server,
  Smile,
  Bot,
  Clock,
  Annoyed,
  TriangleAlert,
  ShoppingBag,
  Book,
  Settings,
  Megaphone,
  LifeBuoy,
  Menu,
  Building2,
  Repeat,
  RefreshCcw,
  BrainCog,
  FilePlus,
  MessageSquareText,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  ChevronUp,
  Pin,
  CircleQuestionMark,
  Plus,
  PauseCircle,
  PlayCircle,
  CheckCheck,
  BookOpen,
  Library,
  UserCircle,
  Languages,
  ShoppingCart,
  ArrowUpDown,
  Volume2,
  FileClock,
  CreditCard,
  UserCheck,
  Zap,
  Inbox,
  MessageCircle,
  Mailbox,
  Contact,
  Group,
  ChartSpline,
  Bolt,
  Briefcase,
  SquareUser,
  Code,
  KeySquare,
  ScanFace,
  BotMessageSquare,
  CircleCheckBig,
  Upload,
  Delete,
  Download,
  Save,
  File,
  FileUp,
  RefreshCw,
  Wrench,
  Settings2,
  ArrowRightFromLine,
  ArrowRight,
  Sun,
  Moon,
  PhoneCall,
  Eye,
  EyeClosed,
  CircleAlert,
  ExternalLink,
  Headphones,
  Lightbulb,
  ListPlus,
  Loader2,
  MessageCircleQuestion,
  MessagesSquare,
  Copy,
  Info,
  X,
  Activity,
  Sparkles,
  Database,
  TrendingUp,
  TrendingDown,
  ShieldCheck,
  CircleUser,
  Check,
  EllipsisVertical,
  Package,
  PartyPopper,
  PlugZap,
  Power,
  User,
  Building,
  Trash,
  EyeOff,
  CircleX,
  MessageCirclePlus,
  MessageCircleWarning,
  MessageCircleX,
  MessageCircleCode,
  MessageCircleQuestionMark,
  UserRoundX,
  Wallet,
  MapPin,
} from 'lucide-vue-next';

const props = defineProps({
  name: {
    type: String,
    required: true
  },
  size: {
    type: [Number, String],
    default: 24
  },
  color: {
    type: String,
    default: undefined
  },
  strokeWidth: {
    type: Number,
    default: undefined
  },
  class: {
    type: String,
    default: undefined
  }
});

const iconMap = {
  'user-plus': UserPlus,
  'folder': Folder,
  'tag': Tag,
  'message-square': MessageSquare,
  'mail': Mail,
  'send': Send,
  'cloud': Cloud,
  'globe': Globe,
  'users': Users,
  'at-sign': AtSign,
  'mail-x': MailX,
  'chart-no-axes-column': ChartNoAxesColumn,
  'server': Server,
  'smile': Smile,
  'bot': Bot,
  'clock': Clock,
  'annoyed': Annoyed,
  'triangle-alert': TriangleAlert,
  'alert-triangle': TriangleAlert,
  'shopping-bag': ShoppingBag,
  'book': Book,
  'settings': Settings,
  'megaphone': Megaphone,
  'life-buoy': LifeBuoy,
  'menu': Menu,
  'building-2' : Building2,
  'building': Building,
  'repeat' : Repeat,
  'refresh-ccw': RefreshCcw,
  'brain-cog' : BrainCog,
  'file-plus' : FilePlus,
  'message-square-text' : MessageSquareText,
  'chevron-left' : ChevronLeft,
  'chevron-right' : ChevronRight,
  'chevron-down' : ChevronDown,
  'chevron-up' : ChevronUp,
  'arrow-right': ArrowRight,
  'pin': Pin,
  'circle-question-mark': CircleQuestionMark,
  'plus': Plus,
  'pause-circle': PauseCircle,
  'play-circle': PlayCircle,
  'check-check': CheckCheck,
  'book-open': BookOpen,
  'library': Library,
  'contact-card-group': UserCircle,
  'languages': Languages,
  'cart': ShoppingCart,
  'arrow-swap': ArrowUpDown,
  'sound-source': Volume2,
  'document-list-clock': FileClock,
  'credit-card-person': CreditCard,
  'scan-person': UserCheck,
  'flash-on': Zap,
  'inbox': Inbox,
  'message-circle': MessageCircle,
  'mailbox': Mailbox,
  'contact': Contact,
  'group': Group,
  'chart-spline': ChartSpline,
  'bolt': Bolt,
  'briefcase': Briefcase,
  'square-user': SquareUser,
  'code': Code,
  'key-square': KeySquare,
  'scan-face': ScanFace,
  'zap': Zap,
  'bot-message-square': BotMessageSquare,
  'file-clock': FileClock,
  'credit-card': CreditCard,
  'circle-check-big': CircleCheckBig,
  'check-circle-big': CircleCheckBig,
  'upload': Upload,
  'file-up': FileUp,
  'delete': Delete,
  'download': Download,
  'save': Save,
  'file': File,
  'refresh-cw': RefreshCw,
  'wrench': Wrench,
  'settings-2': Settings2,
  'arrow-right-from-line': ArrowRightFromLine,
  'sun': Sun,
  'moon': Moon,
  'phone-call': PhoneCall,
  'eye': Eye,
  'eye-closed': EyeClosed,
  'eye-off': EyeOff,
  'circle-alert': CircleAlert,
  'external-link': ExternalLink,
  'headphones': Headphones,
  'lightbulb': Lightbulb,
  'list-plus': ListPlus,
  'loader-2': Loader2,
  'message-circle-question': MessageCircleQuestion,
  'messages-square': MessagesSquare,
  'copy': Copy,
  'info': Info,
  'x': X,
  'activity': Activity,
  'sparkles': Sparkles,
  'database': Database,
  'trending-up': TrendingUp,
  'trending-down': TrendingDown,
  'shield-check': ShieldCheck,
  'circle-user': CircleUser,
  'check': Check,
  'ellipsis-vertical': EllipsisVertical,
  'package': Package,
  'party-popper': PartyPopper,
  'plug-zap': PlugZap,
  'power': Power,
  'user': User,
  'trash': Trash,
  'circle-x': CircleX,
  'message-circle-plus': MessageCirclePlus,
  'message-circle-warning': MessageCircleWarning,
  'message-circle-x': MessageCircleX,
  'message-circle-code': MessageCircleCode,
  'message-circle-question-mark': MessageCircleQuestionMark,
  'user-round-x': UserRoundX,
  'wallet': Wallet,
  'map-pin': MapPin,
};

const icon = computed(() => iconMap[props.name]);
</script>

<template>
  <component
    :is="icon"
    :size="size"
    :color="color"
    :stroke-width="strokeWidth"
    :class="props.class"
  />
</template>
